export default {
	"coupon.SimilarCouponsAreMutuallyExclusive": "同类券互斥",
	"coupon.ThereAreNoCoupons": "暂无相关优惠券",
	"coupon.WaiverOfOffer": "放弃优惠",
	"coupon.ReasonsForUnavailability": "不可用原因：",
	"coupon.Selected": "已选",
	"coupon.sheet": "张",
	"coupon.¥reductionIsAvailable": "可减￥",
	"coupon.AreYouSure": "确定"
}